import React, { useContext, useState } from "react";
import styled, { keyframes } from 'styled-components';
import Cover from "../components/Cover";
import About from "../components/About";
import Eduexp from "../components/Eduexp";
import Projects from "../components/Projects";
import BlogSection from "../components/BlogSection";
import Contact from "../components/Contact";
import Particles from '../components/Particles';
import FloatingParticles from "../components/FloatingParticle";
import StarContext from "../context/StarContext";
import GitProjects from "../components/GitProjects";
import WorkingOnIt from "./WorkingOnIt";

const Wrapper = styled.div`
  /* width: 100vw; */
  margin: 56px 0;
  position: relative;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 56px 0;
  `;

const CanvasContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1; 
  /* pointer-events: none; */
`;

const Profile = () => {
  const { isStarEnabled } = useContext(StarContext);

  return (
    <>
      {/* <Wrapper>
        <Cover />
      </Wrapper>
      <Container>
        <About />
      </Container>
      <Container>
        <Eduexp />
      </Container>
      <Container>
        <GitProjects />
      </Container>
      <Container id='contact'>
        <Contact />
      </Container>
      <CanvasContainer>
        <Particles />
      </CanvasContainer>
      {isStarEnabled && (<FloatingParticles />)} */}
      <WorkingOnIt />
    </>
  );
};

export default Profile;
